import { Injectable } from '@angular/core';
import { Actions as EffectActions, createEffect, ofType } from '@ngrx/effects';
import { ActionType } from '../companies/store/actions/companies.actions';
import { Observable, of, throwError } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import * as Actions from '../companies/store/actions/companies.actions';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Company } from './companies.model';
import { CompaniesService } from './companies.service';


@Injectable({
  providedIn: 'root'
})
export class CompaniesEffects {

  url = 'https://localhost:44358';

  constructor(
    private actions$: EffectActions,
    private http: HttpClient,
    private companiesService: CompaniesService
  ) { }

  
  fetchCompaniesByCompanyIdRequestFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.FETCH_COMPANY),
      mergeMap((action: Actions.FetchCompany) => {

        return this.companiesService.getCompaniesByCompanyId$(action.companyId)
          .pipe(
            mergeMap((response: any) => {
              response.forEach((company: any) => {
                company.startDate = company.startDate.toDate();
              });
              return ([
                new Actions.FetchCompanySuccess(response)
              ]);
            }
            ),
            catchError(err => {
              console.log('Handling error locally and rethrowing it...', err);
              return of(new Actions.FetchCompanyFailed(err));
            })

          );
      })
    ));
  // @Effect()
  // fetchCompaniesRequest = this.actions$
  //   .pipe(
  //     ofType(ActionType.FETCH_COMPANYS),
  //     mergeMap((action: Actions.FetchCompanies) => {

  //       const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  //       return this.http.get<Company[]>(this.url + '/api/Companies', httpOptions)
  //         .pipe(
  //           mergeMap((response: any) => {
  //             console.log('fetchCompaniesRequest...', response);
  //             return ([
  //               new Actions.FetchCompaniesSuccess(response)
  //             ]);
  //           }
  //           ),
  //           catchError(err => {
  //             console.log('Handling error locally and rethrowing it...', err);
  //             return of(new Actions.FetchCompaniesFailed(err));
  //           })

  //         );
  //     })
  //   );

  
  fetchCompaniesRequestFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.FETCH_COMPANYS),
      mergeMap((action: Actions.FetchCompanies) => {

        return this.companiesService.getCompanies$()
          .pipe(
            mergeMap((response: any) => {
              response.forEach((company: any) => {
                company.dsEndDate = company.dsEndDate.toDate();
                company.startDate = company.startDate.toDate();
              });
              console.log('fetchCompaniesRequest...', response);
              return ([
                new Actions.FetchCompaniesSuccess(response)
              ]);
            }
            ),
            catchError(err => {
              console.log('Handling error locally and rethrowing it...', err);
              return of(new Actions.FetchCompaniesFailed(err));
            })

          );
      })
    ));

  // @Effect()
  // fetchCompanyRequest = this.actions$
  //   .pipe(
  //     ofType(ActionType.FETCH_COMPANY),
  //     mergeMap((action: Actions.FetchCompany) => {
  //       console.log('fetchCompanyRequest...');
  //       const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  //       return this.http.get<Company[]>(this.url + '/api/Companies/' + action.companyId, httpOptions)
  //         .pipe(
  //           mergeMap((response: any) => {
  //             console.log('fetchCompanyRequest...', response);
  //             return ([
  //               new Actions.FetchCompanySuccess(response)
  //             ]);
  //           }
  //           ),
  //           catchError(err => {
  //             console.log('Handling error locally and rethrowing it...', err);
  //             return of(new Actions.FetchCompanyFailed(err));
  //           })

  //         );
  //     })
  //   );

  
  addCompanyFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.ADD_COMPANY),
      mergeMap(async (action: Actions.AddCompany) => {

        const company = action.company;

        await this.companiesService.addCompanyFirebase$(company)
          .then((response) => {
            company.id = response.id;
            console.log('company...', company);
          }).catch((err) => {

            console.log('err in catch...', err);
          });

        if (company.id !== null) {
          return new Actions.AddCompanySuccess(company);
        } else {
          return new Actions.AddCompanyFailed();
        }
      })
    ));

  
  deleteBug = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.DELETE_COMPANY),
      mergeMap((action: Actions.DeleteCompany) => {
        const id = action.id;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

        return this.http.delete<number>(this.url + '/api/Companies/' + id, httpOptions)
          .pipe(
            mergeMap((response: any) => {
              console.log('response...', response);
              return ([
                new Actions.DeleteCompanySuccess(response.id)
              ]);
            }
            ),
            catchError(err => {
              console.log('Handling error locally and rethrowing it...', err);
              return of(new Actions.DeleteCompanyFailed());
            })

          );
      })
    ));

  
  destroyChannelFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.DESTROY_COMPANY),
      mergeMap(async (action: Actions.DestroyCompany) => {

        const id = action.id;

        await this.companiesService.destroyCompanyFirebase$(id)
          .then((response) => {
            console.log('response...', response);
          }).catch((err) => {
            console.log('err in catch...', err);
          });

        if (id !== null) {
          return new Actions.DestroyCompanySuccess(id);
        } else {
          return new Actions.DestroyCompanyFailed();
        }
      })
    ));

  // @Effect()
  // destrpuMediaLibrary = this.actions$
  //   .pipe(
  //     ofType(ActionType.DESTROY_COMPANY),
  //     mergeMap((action: Actions.DestroyCompany) => {
  //       const id = action.id;
  //       const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  //       return this.http.delete<number>(this.url + '/api/Companies/' + id, httpOptions)
  //         .pipe(
  //           mergeMap((response: any) => {
  //             console.log('response...', response);
  //             return ([
  //               new Actions.DestroyCompanySuccess(response.id)
  //             ]);
  //           }
  //           ),
  //           catchError(err => {
  //             console.log('Handling error locally and rethrowing it...', err);
  //             return of(new Actions.DestroyCompanyFailed());
  //           })

  //         );
  //     })
  //   );

  
  fetchCompaniesByCompanyNameRequest = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.FETCH_COMPANIES_BY_COMPANYNAME),
      mergeMap((action: Actions.FetchCompaniesByCompanyName) => {

        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

        return this.http.get<Company[]>(this.url + '/api/Companies/GetCompaniesByCompanyName/' + action.companyName, httpOptions)
          .pipe(
            mergeMap((response: any) => {
              console.log('action.companyName...', action.companyName);
              console.log('fetchCompaniesByCompanyNameRequest...', response);
              return ([
                new Actions.FetchCompaniesByCompanyNameSuccess(response)
              ]);
            }
            ),
            catchError(err => {
              console.log('Handling error locally and rethrowing it...', err);
              return of(new Actions.FetchCompaniesByCompanyNameFailed(err));
            })

          );
      })
    ));

  // @Effect()
  // updateCompany = this.actions$
  //   .pipe(
  //     ofType(ActionType.UPDATE_COMPANY),
  //     mergeMap((action: Actions.UpdateCompany) => {

  //       const message = action.company;
  //       const id = action.company.id;
  //       const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  //       const company = action.company;

  //       return this.http.put<Company>(this.url + '/api/Companies/' + id, company, httpOptions)
  //         .pipe(
  //           mergeMap((response: any) => {

  //             console.log('response updateBug...', company);
  //             return ([
  //               new Actions.UpdateCompanySuccess(company.id, company)
  //             ]);
  //           }
  //           ),
  //           catchError(err => {
  //             console.log('Handling error locally and rethrowing it...', err);
  //             return of(new Actions.UpdateCompanyFailed());
  //           })

  //         );
  //     })
  //   );

  
  updateCompanyFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.UPDATE_COMPANY),
      mergeMap((action: Actions.UpdateCompany) => {

        const company = action.company;

        return this.companiesService.updateCompanyFirebase$(company)
          .pipe(
            mergeMap((response: any) => {

              console.log('response updateBugFirebase...', company);
              company.id = '';
              return ([
                new Actions.UpdateCompanySuccess(company.id, company)
              ]);
            }
            ),
            catchError(err => {
              console.log('Handling error locally and rethrowing it...', err);
              return of(new Actions.UpdateCompanyFailed());
            })

          );
      })
    ));
}
